import { Heading1, Heading2, Paragraph } from "@sikt/sds-core";
import { Alert } from "@sikt/sds-message";
import { QRCodeSVG } from "qrcode.react";
import { useParams } from "react-router-dom";
import { CopyField } from "../components/CopyField";
import { NotFoundNotice } from "../components/NotFoundNotice";
import { ResultsChart } from "../components/ResultsChart";
import { useLiveResults } from "../lib/useLiveResults";
import styles from "./ResultsPage.module.css";

export function ResultsPage() {
  const { resultsId } = useParams();
  const { vote, results, status } = useLiveResults(resultsId);

  if (status === "notfound") {
    return <NotFoundNotice what="resultatvisningen" />;
  }
  if (status === "error") {
    return (
      <Alert variant="critical">
        <Paragraph>
          Klarte ikke å hente resultatene. Last siden på nytt for å prøve
          igjen.
        </Paragraph>
      </Alert>
    );
  }
  if (!vote || !results) {
    return (
      <div aria-live="polite">
        <Paragraph>Henter resultater …</Paragraph>
      </div>
    );
  }

  const summary =
    vote.mode === "dots"
      ? `${results.totalBallots} ${results.totalBallots === 1 ? "deltaker" : "deltakere"} har fordelt ${results.totalDots ?? 0} stemmer`
      : `${results.totalBallots} ${results.totalBallots === 1 ? "svar" : "svar"} så langt`;

  const voteUrl = `${window.location.origin}/v/${vote.voteId}`;

  return (
    <div className={styles.page}>
      <div className={styles.head}>
        <Heading1 size="xl">{vote.title}</Heading1>
        <Paragraph size="l">{summary}</Paragraph>
        <span className={styles.status} data-state={status} aria-live="polite">
          <Paragraph as="span" size="s" color="secondary">
            {status === "live"
              ? "Direkte – oppdateres automatisk"
              : "Mistet forbindelsen – kobler til på nytt …"}
          </Paragraph>
        </span>
      </div>

      <section className={styles.panel} aria-label="Resultater">
        <ResultsChart
          options={vote.options}
          counts={results.counts}
          mode={vote.mode}
        />
      </section>

      <section className={styles.share} aria-labelledby="del-heading">
        <Heading2 id="del-heading" size="xs">
          Få med flere
        </Heading2>
        <div className={styles.shareRow}>
          <figure className={styles.qr}>
            <QRCodeSVG
              className={styles.qrCode}
              value={voteUrl}
              size={168}
              marginSize={3}
              title="QR-kode med lenke til avstemningen"
            />
            <figcaption>
              <Paragraph as="span" size="s" color="secondary">
                Skann for å stemme
              </Paragraph>
            </figcaption>
          </figure>
          <div className={styles.copy}>
            <CopyField
              label="Stemmelenke – del med deltakerne"
              value={voteUrl}
            />
          </div>
        </div>
      </section>
    </div>
  );
}
